// extracted by mini-css-extract-plugin
export default {"root":"warehouse-sidebar-item_root__rqyz7","icon":"warehouse-sidebar-item_icon__JHmH3","profit":"warehouse-sidebar-item_profit__t5DDp","label":"warehouse-sidebar-item_label__r1elB"};